import React from "react";
import { LockIcon } from "lucide-react";
const logos = [{
  name: "American Express",
  src: "https://cdn.magicpatterns.com/uploads/ijerff5VVoMAhqoJDKkxHG/image.png"
}, {
  name: "Visa",
  src: "https://cdn.magicpatterns.com/uploads/v9hhAr2PVDnnp5P9P9xKyS/image.png"
}, {
  name: "Mastercard",
  src: "https://cdn.magicpatterns.com/uploads/ozWKWAzf58d79AkFtdCdCG/image.png"
}, {
  name: "Apple Pay",
  src: "https://cdn.magicpatterns.com/uploads/5kQAb81kgpktmjcAZsi9se/image.png"
}, {
  name: "Google Pay",
  src: "https://cdn.magicpatterns.com/uploads/32jHjHJQqArTSnADXbbC6h/image.png"
}];
export function PaymentLogos({
  centered = false
}: {
  centered?: boolean;
}) {
  if (centered) {
    return <div className="flex flex-col items-center gap-3" data-id="element-184" data-mp="3ftac9l6o5of5">
        <div className="flex flex-wrap justify-center gap-2" data-id="element-185" data-mp="3fvwk7lxh25xw">
          {logos.map(p => <span key={p.name} className="flex h-10 w-16 items-center justify-center rounded border border-neutral-200 bg-white px-1.5" data-id="element-186" data-mp="104s7xezhtfwt">
              <img src={p.src} alt={p.name} className="max-h-7 max-w-full object-contain" data-id="element-187" data-mp="3v46fukhoucqx" />
            </span>)}
        </div>
        <p className="flex items-center gap-1.5 text-sm text-ink" data-id="element-188" data-mp="3w2ahfpjf3ur">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-189" data-mp="8vx5nvgciflm" />
          100% safe & secure checkout
        </p>
      </div>;
  }
  return <div className="flex flex-wrap items-center gap-2 text-xs text-ink-muted" data-id="element-190" data-mp="cx8vo234t2uc">
      <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-191" data-mp="3cegl1xdxdqz0" />
      <span data-id="element-192" data-mp="3hc0altg2pq69">Secure checkout</span>
      {logos.map(p => <span key={p.name} className="flex h-8 w-12 items-center justify-center rounded border border-neutral-200 bg-white px-1" data-id="element-193" data-mp="3hci7msak88f8">
          <img src={p.src} alt={p.name} className="max-h-6 max-w-full object-contain" data-id="element-194" data-mp="3q4bokfu03l5c" />
        </span>)}
    </div>;
}